import { Icon, toIconsEnum } from 'components/Icons';

import { IconLabelWeatherRenderedProps } from '.';

export const IconLabelWeatherRendered = ({ value }: IconLabelWeatherRenderedProps) => {
  return (
    <>
      <Icon iconId={toIconsEnum(`meteo-${value.toLowerCase()}`)} />
      <span>{value}</span>
    </>
  );
};
